import { render, staticRenderFns } from "./ProductImportPage.vue?vue&type=template&id=68ab7fb2&scoped=true&"
import script from "./ProductImportPage.vue?vue&type=script&lang=js&"
export * from "./ProductImportPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductImportPage.vue?vue&type=style&index=0&id=68ab7fb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ab7fb2",
  null
  
)

export default component.exports